var _path, _path2, _path3, _g, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 280,
    viewBox: "0 0 242 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M120.955 278.736L1.36389 209.701V70.1165L120.955 139.152V278.736Z",
    fill: "url(#paint0_linear_37_101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M121 278.736L240.591 209.701V70.1165L121 139.152V278.736Z",
    fill: "#201491"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M120.606 138.625L0 208.703L121.394 278.78L242 208.703L120.606 138.625Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.046 221.532C155.005 221.532 183.344 193.198 183.344 158.246C183.344 123.294 155.005 94.9597 120.046 94.9597C85.0881 94.9597 56.7488 123.294 56.7488 158.246C56.7488 193.198 85.0881 221.532 120.046 221.532Z",
    fill: "url(#paint1_radial_37_101)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.2689,
    y: 76.2427,
    width: 167.463,
    height: 166.878,
    fill: "url(#pattern1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.726828 69.6452L25.9183 84.5644V194.499L0.111328 209.767L0.726828 69.6452Z",
    fill: "url(#paint2_linear_37_101)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0947266 209.507L121 279.285V251.104L26.0514 194.321L0.0947266 209.507Z",
    fill: "url(#paint3_linear_37_101)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M120.29 0L0.726562 69.4678L121.072 138.936L240.636 69.4678L120.29 0Z",
    fill: "url(#paint4_linear_37_101)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M241.268 69.6453L216.076 84.5645V194.499L241.883 209.767L241.268 69.6453Z",
    fill: "url(#paint5_linear_37_101)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.9 209.507L121 279.285V251.104L215.949 194.321L241.9 209.507Z",
    fill: "url(#paint6_linear_37_101)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M120.318 280L0.726562 210.965V71.3806L120.318 140.416V280Z",
    fill: "url(#paint7_linear_37_101)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M120.362 278.736L239.954 209.701V70.1165L120.362 139.152V278.736Z",
    fill: "#201491"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.142 138.276L120.756 280L119.37 138.276H122.142Z",
    fill: "url(#paint8_linear_37_101)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.726562 69.6453L8.33448 73.7535L15.9146 77.906L31.075 86.2166C41.156 91.794 51.2315 97.388 61.2793 103.026C71.3436 108.637 81.3581 114.331 91.4003 119.986L121.444 137.078H120.069L150.073 119.986C160.099 114.331 170.102 108.637 180.156 103.026C190.192 97.388 200.257 91.794 210.326 86.2166L225.465 77.906L233.034 73.7535L240.631 69.6453L233.244 74.1138L225.831 78.538L211.003 87.3864C201.094 93.2466 191.179 99.0956 181.231 104.895C171.305 110.727 161.33 116.471 151.376 122.253L121.444 139.479L120.756 139.873L120.069 139.479L90.0973 122.259C80.1327 116.471 70.1459 110.733 60.2035 104.9C50.25 99.1011 40.3187 93.2521 30.3985 87.392L15.5487 78.5436L8.12376 74.1194L0.726562 69.6453Z",
    fill: "url(#paint9_linear_37_101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_101"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_37_101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_101",
    x1: 1.3614,
    y1: 174.425,
    x2: 120.953,
    y2: 174.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976,
    stopColor: "#3CFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2342,
    stopColor: "#3CE6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#3CCBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#3CB7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    stopColor: "#3CABFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA7FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_37_101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.048 158.246) scale(63.2996 63.2881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1077,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5117,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#F8EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_101",
    x1: 13.0144,
    y1: 209.765,
    x2: 13.0144,
    y2: 69.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1077,
    stopColor: "#3CA9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2342,
    stopColor: "#3CC0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#3CDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#3CEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8052,
    stopColor: "#3CFBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CFFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_101",
    x1: 0.0960574,
    y1: 236.803,
    x2: 120.998,
    y2: 236.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#3C70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2761,
    stopColor: "#3C84FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5146,
    stopColor: "#3C97FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#3CA3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_101",
    x1: 0.728725,
    y1: 69.4684,
    x2: 240.634,
    y2: 69.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B04BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    stopColor: "#BD4BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9521,
    stopColor: "#DF4BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E24BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_37_101",
    x1: 228.981,
    y1: 209.765,
    x2: 228.981,
    y2: 69.6426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7.66773e-8,
    stopColor: "#201448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    stopColor: "#20144C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6491,
    stopColor: "#201458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8923,
    stopColor: "#201466"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_37_101",
    x1: 241.9,
    y1: 236.803,
    x2: 120.997,
    y2: 236.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1077,
    stopColor: "#201491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1698,
    stopColor: "#201487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3744,
    stopColor: "#20146C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#201458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7889,
    stopColor: "#20144C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201448"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_37_101",
    x1: 0.728725,
    y1: 175.691,
    x2: 120.321,
    y2: 175.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976,
    stopColor: "#3CFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2342,
    stopColor: "#3CE6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#3CCBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#3CB7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    stopColor: "#3CABFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CA7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_37_101",
    x1: 120.758,
    y1: 280,
    x2: 120.758,
    y2: 138.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_37_101",
    x1: 0.0405205,
    y1: 104.76,
    x2: 241.323,
    y2: 104.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5528,
    stopColor: "#FFB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_101",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAACnCAYAAACW7wC8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_37_101",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS4AAAEtCAYAAAC21I3tAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCub);
export default __webpack_public_path__ + "static/media/ic_cub.7adafea8a177f6471dba18b6ffe50a2f.svg";
export { ForwardRef as ReactComponent };